import front from './front';
import back from "./back";

export default {
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    linkExactActiveClass: 'active',
    routes: [
        /*{
            path: '/:lang',
            component: {render: (c) => c('router-view')},
            children: []
        },*/
        // ...front,
        ...back,
        {
            path: '*', hidden: true,
            redirect: to => ({
                name: 'dashboard',
                query: { redirect: to.fullPath }
            })
        }

    ],
    scrollBehavior(to, from, saved) {
        if(saved) return saved;
        const p = {x: 0, y: 0};
        if (to.hash) p.selector = to.hash;
        return p; //if (to.matched.some(m => m.meta.scrollToTop)) { p.x = 0; p.y = 0 }
    }
}